module.exports = __webpack_public_path__ + "static/media/screenshot_storer.25924f20.png";